import { API_PATH } from "src/const/api-urls";
import { FR_HEADER, TO_HEADER } from "src/const/const-from-env";
import { BaseResponse } from "src/interface";
import { createCreDtTm, createMSGID } from "src/utils/helper";
import httpsService from "./httpsService";

export interface IChannelsResponseItem {
  systemId: string;
  channel: {
    channelCode: string;
    channelName: string;
    status: string;
  };
  partner: {
    partnerName: string;
    partnerCode: string;
    logo: string;
    status: string;
  };
}
export interface IChannelsResponse {
  data: IChannelsResponseItem[]
  msgSts: any
}


export const getChannels = (frSystm: string) => {
  return httpsService.get<null, BaseResponse<IChannelsResponse>>(API_PATH.CHANNEL, {
    headers: { creDtTm: createCreDtTm(), frSystm: frSystm, toSystm: TO_HEADER},
    params: { msgId: createMSGID(frSystm) },
  });
};
